import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import Btn from './btn.vue'

export default {
    name: "ReportPush",
    components: { iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            searchValue: "",
            taskId: '',
            BrandList: [],
            formInline: {
                filterItem: '',
                filterParam: ''
            },
            options: [
                {
                    value: '0',
                    label: this.$t('common.all')
                },
                {
                    value: '1',
                    label: this.$t('PlatformSettings.userName') 
                },
                {
                    value: '2',
                    label: this.$t('PlatformSettings.loginName') 
                },
                {
                    value: '3',
                    label: this.$t('PlatformSettings.email') 
                },
            ],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false,
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "userName",
                    label: this.$t('PlatformSettings.userName'),
                    align: "center",
                },
                {
                    prop: "loginName",
                    label: this.$t('PlatformSettings.loginName'),
                    align: "center",
                },
                {
                    prop: "email",
                    label: this.$t('PlatformSettings.email'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('common.orgName'),
                    align: "center",
                },
                {
                    prop: 'state',
                    label: this.$t('PlatformSettings.operate'),
                    align: 'center',
                    width: "160px",
                    render: (h, params) => {
                        return h(Btn, {
                            props: {
                                list: this.btnList,
                                item: params
                            },
                            on: {
                                clickBtn: (row) => {
                                    console.log(params.row)
                                    const state = params.row.status === 1 ? 0 : 1
                                    if(row.label == this.$t('PlatformSettings.subscribe') ) {
                                        this.btnOperation(params.row, state)
                                    }else {
                                        this.updateState(params.row, state)
                                    }
                                }
                            }
                        })
                    }
                }
            ],
            btnList: [
                { label: this.$t('PlatformSettings.subscribe'), type: 'primary', filed: 'begin', disabled: 'is_begin' },
                { label: this.$t('common.btn.cancel'), filed: 'disable', disabled: 'is_disable' },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            dialogVisible: false,
            radio: 1,
            userId: ''
        }
    },
    created() {
        this.getBrand()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getBrand() {
            let param = {
                name: this.searchValue
            }
            this.$store.dispatch('ReportPush/GET_QUERYTASKREPORT', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.BrandList = res.data.data
                        this.taskId = res.data.data[0].id
                        this.getModel()
                    }
                }
            }).catch(err => { })
        },
        getModel() {
            let param = {
                taskId: this.taskId,
                filterItem: this.formInline.filterItem,
                filterParam: this.formInline.filterParam,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('ReportPush/GET_QUERYTASKUSER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.list.map(item => {
                            if (item.status === 0) {
                                item['is_begin'] = true
                                item['is_disable'] = false
                            } else {
                                item['is_begin'] = false
                                item['is_disable'] = true
                            }
                        })
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getModel()
        },
        onClear() {
            this.formInline = {
                filterItem: '',
                filterParam: ''
            }
            this.getModel()
        },
        ChangModel(val) {
            this.brandId = val
            this.getModel()
        },
        btnOperation(row) {
            console.log(row)
            this.dialogVisible = true
            this.userId = row.userId
        },
        changeSwitch() {
            let param = {
                userId: this.userId,
                taskId: this.taskId,
                taskType: this.radio
            }
            this.$store.dispatch('ReportPush/GET_SUBSREPORTS', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('PlatformSettings.form.sendSuccess') )
                        this.dialogVisible = false
                        this.getModel()

                    } else {
                        this.$message.success(res.msg)
                    }
                }
            })
        },
        updateState(row, index) {
            console.log(row)
            let param = {
                userId: row.userId,
                taskId: this.taskId,
                taskType: row.taskType,
                status: row.status
            }
            this.$store.dispatch('ReportPush/GET_CANCELREPORT',param).then(res=>{
              if(res){
                if(res.data.code == 200){
                    this.$message.success(this.$t('PlatformSettings.form.cancelSuccess') )
                    this.getModel()
                  
                }else{
                  this.$message.success(res.msg)
                }
              }
            }).catch(err=>{})
        },
        handleClose() {
            this.dialogVisible = false
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getModel();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}